import { css } from '@emotion/react';
import { fontSizes, fontWeights, colorVariables } from '@gumtree/ui-library/src/base/theme';
import styled from '@emotion/styled';
import ClearFiltersButton from '../filters-grid-view/clear-filters-button';

export const searchButtonCss = (theme) => css`
    && {
        display: flex;
        justify-content: center;
        width: 100%;
        background-color: ${theme.palette.primary.main};

        &:hover {
            background: ${theme.palette.primary.dark};
        }
    }
`;

export const multiSearchButtonCss = (theme) => css`
    && {
        display: flex;
        justify-content: center;
        box-size: border-box;
        width: 223px;
        flex: 1;
        padding: 8px;
        font-size: ${fontSizes.base};
        font-weight: ${fontWeights.bold};
        line-height: 24px;
        background-color: ${theme.palette.primary.main};
        border-radius: 4px;
        &:hover {
            background: ${theme.palette.primary.dark};
        }
    }
`;

export const StyledClearButton = styled(ClearFiltersButton)`
    width: 91px;
    color: ${colorVariables.textHighlightedDescription};
    font-weight: ${fontWeights.bold};
    text-decoration: none;
    font-size: ${fontSizes.base};
    &:hover {
        color: ${colorVariables.textHighlightedDescription};
        text-decoration: none;
    }
`;

export const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 36px;
`;
